import { AuthorizedLayout } from './AuthorizedLayout';

export default AuthorizedLayout;
